import {SUBSCRIBE} from '../reducers/reducers-const';
import {Store} from 'redux';
import {updateSubscription} from '../actions';

const LOCAL_STORAGE_KEY = 'wix.marketing.releaseNotes.subscribed';

export function subscriptionMiddleware() {
  return next => action => {
    if (action.type === SUBSCRIBE) {
      typeof window !== 'undefined' &&
      typeof window.localStorage !== 'undefined' &&
      window.localStorage.setItem(LOCAL_STORAGE_KEY, action.subscribed);
    }
    return next(action);
  };
}

export function updateSubscriptionStatus(store: Store) {
  const value = typeof window !== 'undefined' &&
    typeof window.localStorage !== 'undefined' &&
    window.localStorage.getItem(LOCAL_STORAGE_KEY);

  store.dispatch(updateSubscription(Boolean(value)));
}
